import { createTheme } from "@mantine/core";

import { lineHeights } from "#app/theme/v2/lineHeights";

import { mantineColors } from "./colors";
import { fontSizes } from "./fontSizes";
import { fontWeights } from "./fontWeights";
import { radius } from "./radius";
import { shadows } from "./shadows";
import { spacing } from "./spacing";

export const theme = createTheme({
  colors: mantineColors,
  radius,
  spacing,
  shadows,
  fontSizes,
  fontWeights,
  lineHeights,
  fontFamily: "Inter Variable, sans-serif",
  black: "#000000",
  primaryColor: "grey",
});
